import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import BackIcon from '../../components/icons/BackIcon'
import InputField from '../../components/common/InputField'
import PhoneInput from '../../components/common/PhoneInput'

const LoginPage = () => {
  const navigate = useNavigate()
  const { login } = useAuth()

  const [formData, setFormData] = useState({
    phoneNumber: '',
    password: '',
  })

  const handleLogin = async (e) => {
    e.preventDefault()

    try {
      await login(formData)
      navigate('/')
    } catch (_) {
      console.log('error occurred while logging in')
    }
  }

  return (
    <div className="w-full max-w-md mx-auto min-h-screen bg-background shadow-lg rounded-xl overflow-hidden">
      {/* Header with back button */}
      <div className="flex items-center p-4">
        <button
          className="flex items-center justify-center bg-background border border-gray-200 rounded-full w-10 h-10 shadow-sm hover:bg-neutral-200-50 transition-colors duration-200"
          onClick={() => navigate('/')}
          aria-label="Back"
        >
          <BackIcon />
        </button>
      </div>

      {/* Logo */}
      <div className="flex justify-center py-8">
        <img src="/eastsoko-logo.png" alt="Sokooni Logo" className="w-36 object-contain" />
      </div>

      {/* Content */}
      <div className="px-6 pb-8">
        <h1 className="text-2xl font-bold text-foreground text-center font-inter mb-2">
          Welcome to Sokooni
        </h1>
        <p className="text-sm font-medium text-medium-opacity text-center font-inter mb-8">
          Login into your account
        </p>

        <form onSubmit={handleLogin} className="space-y-6">
          <PhoneInput
            id="phoneNumber"
            label="Enter your phone number"
            value={formData.phoneNumber}
            onChange={(phone) => setFormData({ ...formData, phoneNumber: phone })}
            required
          />

          <InputField
            type="password"
            id="password"
            label="Enter your password"
            value={formData.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            placeholder="Enter your password"
            required
          />

          {/* Forgot Password Link */}
          <div className="flex justify-end">
            <button
              type="button"
              onClick={() => navigate('/forgot-password')}
              className="text-tertiary-700 text-base font-medium hover:underline"
            >
              Forgot Password
            </button>
          </div>

          <button
            type="submit"
            className="w-full py-3 bg-gradient-to-r from-secondary-700 to-secondary-500 text-white text-lg font-medium font-inter rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
          >
            Login
          </button>
        </form>

        {/* Signup Section */}
        <div className="mt-8 space-y-4">
          <p className="text-lg text-foreground-muted text-center font-inter">
            Don't have an account yet?
          </p>

          <button
            onClick={() => navigate('/signup')}
            className="w-full py-3 bg-gradient-to-r from-tertiary-700 to-tertiary-600 text-white text-lg font-medium font-inter rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
          >
            Sign Up
          </button>

          {/* Retailer and Wholesaler Links */}
          <div className="flex flex-col items-center space-y-2 pt-4">
            <button
              onClick={() => navigate('/signup/retailer')}
              className="text-tertiary-700 text-lg font-medium hover:underline font-inter"
            >
              Become a retailer
            </button>
            <button
              onClick={() => navigate('/signup/wholesaler')}
              className="text-tertiary-700 text-lg font-medium hover:underline font-inter"
            >
              Become a wholesaler
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginPage
